export const getOrganizedUnitConfigurationFilter = state => state.organizedUnitConfiguration.filter
